export default __webpack_public_path__ + "static/media/logo.93865692.svg";